import routerOptions0 from "/var/jenkins_home/workspace/nearhub-websites-bundle/nearhub-website/node_modules/.pnpm/nuxt@3.13.2_eslint@8.57.1_rollup@4.24.0_sass@1.77.6_terser@5.34.1_typescript@4.9.5_vite@3.2.11/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}